module.exports = __webpack_public_path__ + "img/bg_avatar_male_51.8062d33e.png";